module.exports = __webpack_public_path__ + "img/15_newModelWorker_wsw.a42d752b.png";